import { themeGet } from '@styled-system/theme-get';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
const Table = /*#__PURE__*/styled.table.withConfig({
  displayName: "DocTable__Table",
  componentId: "sc-718xsc-0"
})(["width:100%;border-spacing:0;border-color:", ";"], themeGet('palette.border.tint'));
const Tr = /*#__PURE__*/styled.tr.withConfig({
  displayName: "DocTable__Tr",
  componentId: "sc-718xsc-1"
})(["background-color:", ";"], themeGet('palette.background.light'));
/**
 * @public
 */
export const DocTable = ({
  data,
  columns,
  ...rest
}) => {
  return React.createElement(Box, {
    my: 4,
    ...rest
  }, React.createElement(Table, null, React.createElement("thead", null, React.createElement(Tr, null, columns.map((col, i) => React.createElement("th", {
    key: i,
    style: {
      width: i === 0 ? '25%' : undefined
    }
  }, React.createElement(Text, {
    p: 3,
    textAlign: 'left',
    style: {
      whiteSpace: 'nowrap'
    }
  }, col.heading))))), React.createElement("tbody", null, data.map((row, i) => React.createElement("tr", {
    key: i
  }, columns.map((col, i) => React.createElement("td", {
    key: i,
    style: {
      borderBottom: '1px solid',
      borderColor: 'inherit',
      whiteSpace: col.noWrap ? 'nowrap' : undefined
    }
  }, React.createElement(Text, {
    p: 3
  }, row[col.field]))))))));
};